import React from "react"
import AuthenticationStore from "../../stores/AuthenticationStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import PayrollStore from "../../stores/PayrollStore"
import autobind from "class-autobind"
import PayrollTopCard from "./PayrollTopCard"
import PayrollChartCard from "./PayrollChartCard"
import PayrollHoursSummaryCard from "./PayrollHoursSummaryCard"
import PayrollJobCostingSummaryCard from "./PayrollJobCostingSummaryCard"
import PayrollByHierarchyCard from "./PayrollByHierarchyCard"
import TimecardPopup from "../../components/timecard/timecard_popup/TimecardPopup"
import RefreshIndicator from "material-ui/RefreshIndicator"
import AppStateStore from "../../stores/AppStateStore"
import strings from "../../localization/strings"
import ExportAgainPayrollConfirmDialog from "./ExportAgainPayrollConfirmDialog"
import ExportPayrollTimeConfirmDialog from "./ExportPayrollTimeConfirmDialog"
import { browserHistory } from "react-router"
import AccountStore from "../../stores/AccountStore"
import ExceptionPunchSets from "../../components/exception_punchset/ExceptionPunchSets"
import * as ExceptionFilterActions from "../../actions/ExceptionFilterActions"
import ExceptionFilterStore from "../../stores/ExceptionFilterStore"
import moment from "moment"
import * as payrollActions from "../../actions/PayrollActions"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import * as api from "../../api"
import { IPayrollPayCalendar, IDate, IPayGroup, IPayrollTime, IPayrollTimeHierarchy, IPayrollTimeHierarchyEmployee, IPayrollExpenses, IPayrollExpensesHierarchy, IPayrollExpensesHierarchyEmployee, EPayrollType, IPayrollLockCloseHierarchyIds, IDateRange, IFailedCalcAccrualDataInfoDialogContent, IPayrollPayGroupData, IPayrollExportHierarchyData } from "../../models"
import payrollStore from "../../stores/PayrollStore"
import * as payrollHelper from "../../helpers/payrollHelper"
import * as permissionHelper from "../../helpers/permissionHelper"
import * as utils from "../../helpers/utils"
import ExportPayrollResultDialog from "./ExportPayrollResultDialog"
import PayrollExportHistoryCard from "./PayrollExportHistoryCard"

interface IProps {
	location: any
}
interface IState {
	calculating: boolean
	referenceDate: IDate
	selectedPayCalendar: IPayrollPayCalendar
	selectedPayGroup: IPayGroup
	contentHeight: number
	contentWidth: number
	openExportAgainPayrollConfirmDialog: EPayrollType | null
	exportPayrollTimeResultEmployeeIds: string[]

	viewByJob: boolean
	loadingTime: boolean
	payrollTimeData: IPayrollTime
	openTimecardPopup: boolean
	showOverlayLoading: boolean
	selectedPayrollTimeHierarchies: IPayrollTimeHierarchy[]
	exportHierarchyData: IPayrollExportHierarchyData[]

	loadingExpenses: boolean
	payrollExpensesData: IPayrollExpenses
	payrollPriorPeriodExpensesData: IPayrollExpenses
	selectedPayrollExpensesHierarchies: IPayrollExpensesHierarchy[]

	selectedPayrollPriorPeriodExpensesHierarchies: IPayrollExpensesHierarchy[]
}

export default class Payroll extends React.Component<IProps, IState> {
	private PayrollByHierarchyCard
	private employeeIdForTimecard: string
	private referenceDateForTimecard: IDate
	private recalcPayrollAferCloseTimecardPopup: boolean
	private getPayrollTimeAfterCloseTimcardPopup: boolean
	private initSelectedPayrollTimeState: boolean
	private payrollDates: IDateRange

	private selectedPayrollTimeEmployees: IPayrollTimeHierarchyEmployee[]
	private unapprovedPayrollTimeEmployees: IPayrollTimeHierarchyEmployee[]
	private exportedPayrollTimeEmployees: IPayrollTimeHierarchyEmployee[]

	private selectedPayrollExpensesEmployees: IPayrollExpensesHierarchyEmployee[]
	private unapprovedPayrollExpensesEmployees: IPayrollExpensesHierarchyEmployee[]
	private exportedPayrollExpensesEmployees: IPayrollExpensesHierarchyEmployee[]

	private selectedPayrollPriorPeriodExpensesEmployees: IPayrollExpensesHierarchyEmployee[]

	private payCalendarPayGroups: IPayGroup[]

	constructor(props) {
		super(props)
		const selectedPayGroup = payGroupAndTypeHelper.getPayrollSelectedPayGroup(true)
		const selectedPayrollPayCalendar = payrollHelper.getSelectedPayrollPayCalendar(selectedPayGroup)
		this.payCalendarPayGroups = payrollHelper.getPayGroupsByPayrollPayCalendar(selectedPayrollPayCalendar)

		const referenceDate = moment()
		const storedViewByJob = utils.getCookie("PayrollViewByJob")

		this.state = {
			calculating: false,
			referenceDate,
			selectedPayCalendar: selectedPayrollPayCalendar,
			selectedPayGroup: selectedPayGroup &&
				this.payCalendarPayGroups.find(i => i.Id === selectedPayGroup.Id) ?
				selectedPayGroup :
				this.payCalendarPayGroups.length === 1 ?
					this.payCalendarPayGroups[0] :
					null,
			contentHeight: window.innerHeight,
			contentWidth: 1000,
			openExportAgainPayrollConfirmDialog: null,
			exportPayrollTimeResultEmployeeIds: [],

			viewByJob:
				(
					AccountStore.getJobsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayrollByJob) && storedViewByJob === "true"
				) ||
				!permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll),
			loadingTime: true,
			payrollTimeData: null,
			openTimecardPopup: false,
			showOverlayLoading: false,
			selectedPayrollTimeHierarchies: [],
			exportHierarchyData: null,

			loadingExpenses: true,
			payrollExpensesData: null,
			payrollPriorPeriodExpensesData: null,
			selectedPayrollExpensesHierarchies: [],
			selectedPayrollPriorPeriodExpensesHierarchies: []
		}
		this.payrollDates = payrollHelper.getPayrollDatesByPayCalendar(referenceDate, selectedPayrollPayCalendar)
		this.recalcPayrollAferCloseTimecardPopup = false
		this.getPayrollTimeAfterCloseTimcardPopup = false
		this.employeeIdForTimecard = ""
		this.referenceDateForTimecard = ""
		this.selectedPayrollTimeEmployees = []
		this.selectedPayrollExpensesEmployees = []
		this.selectedPayrollPriorPeriodExpensesEmployees = []
		this.initSelectedPayrollTimeState = false
		autobind(this)
	}

	componentDidMount() {
		document.title = `${strings.Payroll} | ${strings.Findd_Grandd_Central}`
		this.updateDimensions()
		this.getContentWidth()
		PayrollStore.on("payroll_time_change", this.getPayrollTimeChange)
		PayrollStore.on("open_export_payroll_time_result_dialog", this.openExportPayrollTimeResultDialog)
		HierarchySettingsStore.on("global_change", this.handleChangeGlobalHierarchy)
		AppStateStore.on("change", this.getContentWidth)
		AppStateStore.on("get_payroll_time_by_action", this.getPayrollTimeDataByAction)
		ExceptionFilterStore.on("refresh_page", this.exceptionFilterStoreChangeEvent)
		window.addEventListener("resize", this.updateDimensions)
		this.props.location.query.date &&
			this.handleChangeReferenceDate(this.props.location.query.date)
	}

	componentWillUnmount() {
		PayrollStore.removeListener("payroll_time_change", this.getPayrollTimeChange)
		PayrollStore.removeListener("open_export_payroll_time_result_dialog", this.openExportPayrollTimeResultDialog)
		HierarchySettingsStore.removeListener("global_change", this.handleChangeGlobalHierarchy)
		AppStateStore.removeListener("change", this.getContentWidth)
		AppStateStore.removeListener("get_payroll_time_by_action", this.getPayrollTimeDataByAction)
		ExceptionFilterStore.removeListener("refresh_page", this.exceptionFilterStoreChangeEvent)
		window.removeEventListener("resize", this.updateDimensions)
	}

	handleChangeGlobalHierarchy() {
		this.setState({ calculating: false })
	}

	exceptionFilterStoreChangeEvent() {
		ExceptionFilterStore.getRefreshPage() && this.getPayrollTimeData(true)
	}

	getContentWidth() {
		const leftNavWidth = AppStateStore.getExpandNav() === "collapsed" ? 80 : 224
		this.setState({ contentWidth: window.innerWidth - leftNavWidth })
	}

	updateDimensions() {
		this.getContentWidth()
		this.setState({ contentHeight: window.innerHeight })
	}

	getPayGroupIds(): string[] {
		return this.state.selectedPayGroup ? [this.state.selectedPayGroup.Id] : payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.state.selectedPayCalendar)
	}

	getPayrollPayGroupData(payrollTimeHierarchy: IPayrollTimeHierarchy | IPayrollExpensesHierarchy): IPayrollPayGroupData {
		return {
			PayrollHierarchyItemId: payrollTimeHierarchy.HierarchyItem && payrollTimeHierarchy.HierarchyItem.Id ? payrollTimeHierarchy.HierarchyItem.Id : null,
			PayrollPayGroupId: payrollTimeHierarchy.PayrollPayGroupId
		}
	}

	getPayrollPayGroupDataList(payrollTimeHierarchies: (IPayrollTimeHierarchy | IPayrollExpensesHierarchy)[]): IPayrollPayGroupData[] {
		return payrollTimeHierarchies.map(i => this.getPayrollPayGroupData(i))
	}

	getPayrollTimeDataByAction() {
		// we will do it when recalc failed accrual
		this.getPayrollTimeData(true)
	}

	getPayrollTimeChange() {
		const payrollTime = payrollStore.getPayrollTime()
		let selectedPayrollTimeHierarchies = []
		if (this.initSelectedPayrollTimeState) {
			this.PayrollByHierarchyCard &&
				this.PayrollByHierarchyCard.PayrollTimeByHierarchy &&
				this.PayrollByHierarchyCard.PayrollTimeByHierarchy.PayrollTimeByHierarchyTable &&
				this.PayrollByHierarchyCard.PayrollTimeByHierarchy.PayrollTimeByHierarchyTable.setState({
					selectedPayrollHierarchies: []
				})
			this.selectedPayrollTimeEmployees = []
			this.state.payrollTimeData.PayrollTimeHierarchies.forEach((payrollHierarchy, index) => {
				this.PayrollByHierarchyCard &&
					this.PayrollByHierarchyCard.PayrollTimeByHierarchy &&
					this.PayrollByHierarchyCard.PayrollTimeByHierarchy.PayrollTimeByHierarchyTable &&
					this.PayrollByHierarchyCard.PayrollTimeByHierarchy.PayrollTimeByHierarchyTable.PayrollTimeByHierarchyEmployeeRow &&
					this.PayrollByHierarchyCard.PayrollTimeByHierarchy.PayrollTimeByHierarchyTable.PayrollTimeByHierarchyEmployeeRow[index].setState({
						selectedEmployees: []
					})
			})
		}
		else {
			let selectedPayrollTimeEmployees = []
			if (this.getPayrollTimeAfterCloseTimcardPopup) {
				payrollTime.PayrollTimeHierarchies.forEach(item => {
					this.state.selectedPayrollTimeHierarchies.find(selectedItem => selectedItem.HierarchyItem.Id === item.HierarchyItem.Id && selectedItem.PayrollPayGroupId === item.PayrollPayGroupId) &&
						selectedPayrollTimeHierarchies.push(item)
					this.selectedPayrollTimeEmployees.forEach(selectedEmployee => {
						item.PayrollEmployees.forEach(employee => {
							employee.EmployeeId === selectedEmployee.EmployeeId &&
								selectedPayrollTimeEmployees.push(employee)
						})
					})
				})
			}
			this.selectedPayrollTimeEmployees = selectedPayrollTimeEmployees
		}

		this.setState({
			payrollTimeData: payrollTime,
			selectedPayrollTimeHierarchies,
			loadingTime: false,
			showOverlayLoading: false
		})

		const failedCalcAccrualData: IFailedCalcAccrualDataInfoDialogContent[] = payrollTime.PayrollTimeHierarchies.map(i => {
			return {
				PayrollStatusDocId: i.PayrollStatusDocId,
				RecalcAccrualData: i.ClosedData.RecalcAccrualData
			}
		})
		AppStateStore.setFailedCalcAccrualDataInfoDialogContent(failedCalcAccrualData)
	}

	openExportPayrollTimeResultDialog() {
		this.setState({ exportPayrollTimeResultEmployeeIds: PayrollStore.getExportEmployeeIds() })
	}

	getPayrollTimeData(afterCloseTimcardPopup = false) {
		if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll) &&
			!permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayrollByJob)
		) return
		if (this.state.viewByJob && !permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayrollByJob)) return
		if (!this.state.viewByJob && !permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll)) return
		this.getPayrollTimeAfterCloseTimcardPopup = afterCloseTimcardPopup
		this.initSelectedPayrollTimeState = false
		setTimeout(() => payrollActions.getPayrollTimeData(AuthenticationStore.getCookieAccountId(), HierarchySettingsStore.getGlobalLevelItemFilterId(), this.getPayGroupIds(), moment(this.state.referenceDate).utc(true).format(), this.state.viewByJob), 0)
	}

	handleChangeReferenceDate(referenceDate: IDate, payrollDates: IDateRange = null) {
		const referenceDateStr = moment(referenceDate).format()
		this.payrollDates = payrollDates ? payrollDates : payrollHelper.getPayrollDatesByPayCalendar(moment(referenceDate), this.state.selectedPayCalendar)
		this.setState({
			calculating: false,
			referenceDate
		})
		browserHistory.push("/payroll?date=" + encodeURIComponent(referenceDateStr))
	}

	onTimeDownload() {
		payrollActions.downloadPayrollTimeFile(AuthenticationStore.getCookieAccountId(), HierarchySettingsStore.getGlobalLevelItemFilterId(), this.getPayGroupIds(), moment(this.state.referenceDate).utc(true).format())
	}

	onTimeReportDownload() {
		payrollActions.downloadPayrollTimeReportFile(AuthenticationStore.getCookieAccountId(), HierarchySettingsStore.getGlobalLevelItemFilterId(), this.getPayGroupIds(), moment(this.state.referenceDate).utc(true).format())
	}

	checkPayrollTimeHierarchyLocked(selectedPayrollTimeEmployeeIds: string[]) {
		return this.state.payrollTimeData.PayrollTimeHierarchies.find(hierarchy => {
			const payrollHierarchyEmployeeIds = hierarchy.PayrollEmployees.map(e => e.EmployeeId)
			const duplidatedEmployeeIds = selectedPayrollTimeEmployeeIds.filter(item => payrollHierarchyEmployeeIds.includes(item))
			return duplidatedEmployeeIds.length > 0 ?
				hierarchy.LockedData.IsLocked :
				false
		})
	}

	onTimeLock() {
		const selectedCount = this.state.selectedPayrollTimeHierarchies.length
		if (selectedCount === 0 && this.selectedPayrollTimeEmployees.length === 0) {
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_payroll_hierarchy)
		}
		else if (selectedCount === 0 && this.selectedPayrollTimeEmployees.length > 0) {
			const selectedPayrollTimeEmployeeIds = this.selectedPayrollTimeEmployees.map(i => i.EmployeeId)
			this.checkPayrollTimeHierarchyLocked(selectedPayrollTimeEmployeeIds) ?
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Lock_Selected_Employees,
					content: strings.Cannot_lock_selected_employees_because_payroll_hirarchy_locked
				}) :
				AppStateStore.setConfirmDialogContent({
					title: strings.Lock_Payroll_Employees,
					content: strings.Are_you_sure_you_want_to_lock_payroll_employees,
					confirm: () => AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
						this.lockPayrollTimeExpensesHierarchy(true, selectedPayrollTimeEmployeeIds) :
						this.lockPayrollTimeHierarchy(selectedPayrollTimeEmployeeIds)
				})
		}
		else if (this.state.selectedPayrollTimeHierarchies.filter((item) => item.TotalApprovedEmployees !== item.TotalEmployees).length > 0) {
			AppStateStore.setConfirmDialogContent({
				title: strings.Lock_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
						strings.Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_timecard_with_expense :
						strings.Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_timecard :
					strings.formatString(
						AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
							strings.Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_timecard_with_expense :
							strings.Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_timecard,
						selectedCount
					) as string,
				confirm: () => AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
					this.lockPayrollTimeExpensesHierarchy(true, []) :
					this.lockPayrollTimeHierarchy([])
			})
		}
		else {
			AppStateStore.setConfirmDialogContent({
				title: strings.Lock_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					strings.Are_you_sure_you_want_to_lock_payroll_hierarchy :
					strings.formatString(strings.Are_you_sure_you_want_to_lock_payroll_hierarchies, selectedCount) as string,
				confirm: () => AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
					this.lockPayrollTimeExpensesHierarchy(true, []) :
					this.lockPayrollTimeHierarchy([])
			})
		}
	}

	onTimeEmployeeLock() {
		const selectedCount = this.state.selectedPayrollTimeHierarchies.length
		if (selectedCount === 0) {
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_payroll_hierarchy)
		}
		else {
			AppStateStore.setConfirmDialogContent({
				title: strings.Employee_Lock_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					strings.Are_you_sure_you_want_to_employee_lock_payroll_hierarchy :
					strings.formatString(strings.Are_you_sure_you_want_to_employee_lock_payroll_hierarchies, selectedCount) as string,
				confirm: () => AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
					this.employeeLockPayrollTimeExpensesHierarchy(true) :
					this.employeeLockPayrollTimeHierarchy()
			})
		}
	}

	onTimeUnLock() {
		const selectedCount = this.state.selectedPayrollTimeHierarchies.length
		if (selectedCount === 0 && this.selectedPayrollTimeEmployees.length === 0) {
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_payroll_hierarchy)
		}
		else if (selectedCount === 0 && this.selectedPayrollTimeEmployees.length > 0) {
			const selectedPayrollTimeEmployeeIds = this.selectedPayrollTimeEmployees.map(i => i.EmployeeId)
			if (this.checkPayrollTimeHierarchyLocked(selectedPayrollTimeEmployeeIds)) {
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Unlock_Payroll_Employees,
					content: strings.Cannot_unlock_selected_employees_because_payroll_hierarchy_locked
				})
			}
			else {
				const exportedEmployeeIdsTemp = this.state.payrollTimeData.PayrollTimeHierarchies.map(hierarchy => hierarchy.ExportedData.map(i => i.ExportedEmployeeId))
				const exportedEmployeeIds = [].concat.apply([], exportedEmployeeIdsTemp)
				selectedPayrollTimeEmployeeIds.some(item => exportedEmployeeIds.includes(item)) ?
					AppStateStore.setAlertDialogContent({
						title: strings.Cannot_Unlock_Payroll_Employees,
						content: strings.Cannot_unlock_selected_employees_because_exported_employee_exist
					}) :
					AppStateStore.setConfirmDialogContent({
						title: strings.Unlock_Payroll_Employees,
						content: strings.Are_you_sure_you_want_to_unlock_payroll_employees,
						confirm: () => AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
							this.unlockPayrollTimeExpensesHierarchy(true, selectedPayrollTimeEmployeeIds) :
							this.unlockPayrollTimeHierarchy(selectedPayrollTimeEmployeeIds)
					})
			}
		}
		else {
			AppStateStore.setConfirmDialogContent({
				title: strings.Unlock_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					strings.Are_you_sure_you_want_to_unlock_payroll_hierarchy :
					strings.formatString(strings.Are_you_sure_you_want_to_unlock_payroll_hierarchies, selectedCount) as string,
				confirm: () => AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
					this.unlockPayrollTimeExpensesHierarchy(true, null) :
					this.unlockPayrollTimeHierarchy(null)
			})
		}
	}

	onTimeEmployeeUnLock() {
		const selectedCount = this.state.selectedPayrollTimeHierarchies.length
		selectedCount === 0 ?
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_payroll_hierarchy) :
			this.state.selectedPayrollTimeHierarchies.find(i => i.LockedData.IsLocked === true) ?
				AppStateStore.setProgressSnackbarContent(strings.Cannot_employee_unlock_for_locked_hierarchy) :
				AppStateStore.setConfirmDialogContent({
					title: strings.Employee_Unlock_Payroll_Hierarchy,
					content: selectedCount === 1 ?
						strings.Are_you_sure_you_want_to_employee_unlock_payroll_hierarchy :
						strings.formatString(strings.Are_you_sure_you_want_to_employee_unlock_payroll_hierarchies, selectedCount) as string,
					confirm: () => AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
						this.employeeUnlockPayrollTimeExpensesHierarchy(true) :
						this.employeeUnlockPayrollTimeHierarchy()
				})
	}

	onTimeClose() {
		const selectedCount = this.state.selectedPayrollTimeHierarchies.length
		this.state.selectedPayrollTimeHierarchies.filter(item => item.LockedData.IsLocked).length === this.state.selectedPayrollTimeHierarchies.length ?
			AppStateStore.setConfirmDialogContent({
				title: strings.Close_Payroll_Hierarchy,
				content: AccountStore.getAccrualsTimeoffEnabled() ?
					selectedCount === 1 ?
						strings.Are_you_sure_you_want_to_close_payroll_hierarchy_with_leave :
						strings.formatString(strings.Are_you_sure_you_want_to_close_payroll_hierarchies_with_leave, selectedCount) as string :
					selectedCount === 1 ?
						strings.Are_you_sure_you_want_to_close_payroll_hierarchy :
						strings.formatString(strings.Are_you_sure_you_want_to_close_payroll_hierarchies, selectedCount) as string,
				confirm: () => AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
					this.closePayrollTimeExpensesHierarchy(true) :
					this.closePayrollTimeHierarchy()
			}) :
			AppStateStore.setConfirmDialogContent({
				title: strings.Close_Payroll_Hierarchy,
				content: AccountStore.getAccrualsTimeoffEnabled() ?
					selectedCount === 1 ?
						strings.Are_you_sure_you_want_to_close_payroll_hierarchy_before_lock_with_leave :
						strings.formatString(strings.Are_you_sure_you_want_to_close_payroll_hierarchies_before_lock_with_leave, selectedCount) as string :
					selectedCount === 1 ?
						strings.Are_you_sure_you_want_to_close_payroll_hierarchy_before_lock :
						strings.formatString(strings.Are_you_sure_you_want_to_close_payroll_hierarchies_before_lock, selectedCount) as string,
				confirm: () => AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ?
					this.closeUnlockedPayrollTimeExpensesHierarchy(true) :
					this.closeUnlockedPayrollTimeHierarchy()
			})
	}

	onTimeExport() {
		if (this.selectedPayrollTimeEmployees.length === 0) {
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_employee)
			return
		}

		const lockedData = this.selectedPayrollTimeEmployees.map(i => {
			const lockedData = this.state.payrollTimeData.PayrollTimeHierarchies.find(e =>
				e.PayrollEmployees.find(k => k.EmployeeId === i.EmployeeId)).LockedData
			return (lockedData.IsLocked ||
				lockedData.LockedObjData.find(k => k.LockedObjId === i.EmployeeId) ? true : false)
		})
		if (lockedData.find(i => !i) === false) {
			AppStateStore.setProgressSnackbarContent(strings.Cannot_export_payroll_for_unlocked_employee)
			return
		}

		const missingPunchEmployees = this.selectedPayrollTimeEmployees.filter((employee) => {
			return employee.JobCostingSummaryList.filter((item1) => {
				return item1.PayrollPunchSets.filter((punchSet) => {
					return punchSet.PunchOutId ? false : true
				}).length > 0 ? true : false
			}).length > 0 ? true : false
		})
		if (missingPunchEmployees.length > 0) {
			AppStateStore.setAlertDialogContent({
				title: missingPunchEmployees.length === 1 ? strings.Cannot_Export_Payroll_For_Selected_Employee : strings.Cannot_Export_Payroll_For_Selected_Employees,
				content: missingPunchEmployees.length === 1 ?
					strings.Cannot_export_payroll_for_selected_employee_Add_missing_punches :
					strings.Cannot_export_payroll_for_selected_employees_Add_missing_punches
			})
			return
		}

		const exportHierarchyData: IPayrollExportHierarchyData[] = []
		this.selectedPayrollTimeEmployees.forEach(employee => {
			const employeePayrollHierarchy = this.state.payrollTimeData.PayrollTimeHierarchies.find(hierarchy =>
				hierarchy.PayrollEmployees.find(i =>
					i.EmployeeId === employee.EmployeeId
				))
			const existExportHierarchy = exportHierarchyData.find(i => i.HierarchyId == employeePayrollHierarchy.HierarchyItem.Id)
			if (existExportHierarchy) {
				existExportHierarchy.EmployeeCount++;
				if (!employee.AllPunchsetsApproved)
					existExportHierarchy.UnapprovedEmployeeCount++;
				if (employee.Exported)
					existExportHierarchy.ExportedEmployeeCount++;
				existExportHierarchy.TotalHours += employee.TimeTotals.TotalHours
			}
			else {
				exportHierarchyData.push({
					HierarchyId: employeePayrollHierarchy.HierarchyItem.Id,
					HierarchyName: employeePayrollHierarchy.HierarchyItem.Label,
					EmployeeCount: 1,
					UnapprovedEmployeeCount: employee.AllPunchsetsApproved ? 0 : 1,
					ExportedEmployeeCount: employee.Exported ? 1 : 0,
					TotalHours: employee.TimeTotals.TotalHours
				})
			}
		})

		this.setState({ exportHierarchyData })
	}

	showTimecardPopup(employeeId, referenceDate) {
		this.employeeIdForTimecard = employeeId
		this.referenceDateForTimecard = referenceDate
		this.handleTimecardPopup()
	}

	handleTimecardPopup() {
		this.setState({ openTimecardPopup: !this.state.openTimecardPopup })
	}

	closeTimcardPopup() {
		this.handleTimecardPopup()
		if (this.recalcPayrollAferCloseTimecardPopup) {
			this.setState({ showOverlayLoading: true }, () => {
				ExceptionFilterActions.refreshExceptionFilter()
				this.getPayrollTimeData(true)
				this.getPayrollExpensesData()
				this.getPayrollPriorPeriodExpensesData()
			})
			this.recalcPayrollAferCloseTimecardPopup = false
		}
	}

	handleSelectPayrollTimeEmployee(selectedEmployees, unselectedEmployees) {
		const allPayrollTimeHierarchyEmployees = selectedEmployees.concat(unselectedEmployees)
		this.selectedPayrollTimeEmployees = this.selectedPayrollTimeEmployees.filter((item) => {
			return allPayrollTimeHierarchyEmployees.find((unselectItem) => unselectItem.EmployeeId === item.EmployeeId) ? false : true
		})
		this.selectedPayrollTimeEmployees = this.selectedPayrollTimeEmployees.concat(selectedEmployees)
	}

	lockPayrollTimeHierarchy(individualLockEmployeeIds: string[]) {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		payrollActions.lockPayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollTimeHierarchies),
			this.getPayGroupIds(),
			individualLockEmployeeIds,
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
	}

	employeeLockPayrollTimeHierarchy() {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		payrollActions.employeeLockPayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollTimeHierarchies),
			this.getPayGroupIds(),
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
	}

	unlockPayrollTimeHierarchy(individualLockEmployeeIds: string[]) {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		payrollActions.unlockPayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollTimeHierarchies),
			this.getPayGroupIds(),
			individualLockEmployeeIds,
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
	}

	employeeUnlockPayrollTimeHierarchy() {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		payrollActions.employeeUnlockPayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollTimeHierarchies),
			this.getPayGroupIds(),
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
	}

	closePayrollTimeHierarchy() {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		payrollActions.closePayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollTimeHierarchies),
			this.getPayGroupIds(),
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
	}

	closeUnlockedPayrollTimeHierarchy() {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		const unlockedPayrollPayGroupDataList: IPayrollPayGroupData[] = []
		this.state.selectedPayrollTimeHierarchies.forEach((item) => !item.LockedData.IsLocked && unlockedPayrollPayGroupDataList.push(this.getPayrollPayGroupData(item)))
		const unclosedPayrollPayGroupDataList: IPayrollPayGroupData[] = []
		this.state.selectedPayrollTimeHierarchies.forEach((item) => !item.ClosedData.IsClosed && unclosedPayrollPayGroupDataList.push(this.getPayrollPayGroupData(item)))

		payrollActions.lockClosePayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			unlockedPayrollPayGroupDataList,
			unclosedPayrollPayGroupDataList,
			this.getPayGroupIds(),
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId(),
		)
	}

	exportPayrollTimeEmployee(exportAgain = false) {
		const selectedPayrollTimeEmployees = exportAgain ?
			this.selectedPayrollTimeEmployees :
			this.selectedPayrollTimeEmployees.filter((employee) => employee.Exported === false)

		const selectedPayrollTimeEmployeeIds = selectedPayrollTimeEmployees.map(employee => employee.EmployeeId)
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		payrollActions.exportEmployeePayrollTime(
			AuthenticationStore.getCookieAccountId(),
			selectedPayrollTimeEmployeeIds,
			this.getPayGroupIds(),
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
	}

	getPayrollExpensesData() {
		const { referenceDate } = this.state
		if (!AccountStore.getExpensesEnabled() || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ViewPayrollExpense)) return
		if (AccountStore.getExpenseIsPayrollTime()) return

		const accountId = AuthenticationStore.getCookieAccountId()
		const levelIdFilter = HierarchySettingsStore.getGlobalLevelItemFilterId()
		api.getPayrollExpensesData(accountId, levelIdFilter, this.getPayGroupIds(), moment(referenceDate).utc(true).format()).then(res =>
			this.setState({
				payrollExpensesData: res.data,
				loadingExpenses: false
			})
		)
	}

	getPayrollPriorPeriodExpensesData() {
		const { referenceDate } = this.state
		if (!AccountStore.getExpensesEnabled() || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ViewPayrollExpense)) return
		if (AccountStore.getExpenseIsPayrollTime()) return

		const accountId = AuthenticationStore.getCookieAccountId()
		const levelIdFilter = HierarchySettingsStore.getGlobalLevelItemFilterId()
		api.getPayrollPriorPeriodExpensesData(accountId, levelIdFilter, this.getPayGroupIds(), moment(referenceDate).utc(true).format()).then(res =>
			this.setState({
				payrollPriorPeriodExpensesData: res.data,
				loadingExpenses: false
			})
		)
	}

	onExpensesDownload() {
		payrollActions.downloadPayrollExpensesFile(AuthenticationStore.getCookieAccountId(), HierarchySettingsStore.getGlobalLevelItemFilterId(), this.getPayGroupIds(), moment(this.state.referenceDate).utc(true).format(), false)
	}

	onExpensesReportDownload() {
		payrollActions.downloadPayrollExpensesReportFile(AuthenticationStore.getCookieAccountId(), HierarchySettingsStore.getGlobalLevelItemFilterId(), this.getPayGroupIds(), moment(this.state.referenceDate).utc(true).format())
	}

	checkPayrollExpensesHierarchyLocked(selectedPayrollExpensesEmployeeIds: string[]) {
		return this.state.payrollExpensesData.PayrollExpensesHierarchies.find(hierarchy => {
			const payrollHierarchyEmployeeIds = hierarchy.Employees.map(e => e.EmployeeId)
			const duplidatedEmployeeIds = selectedPayrollExpensesEmployeeIds.filter(item => payrollHierarchyEmployeeIds.includes(item))
			return duplidatedEmployeeIds.length > 0 ?
				hierarchy.LockedData.IsLocked :
				false
		})
	}

	onExpensesLock() {
		const selectedCount = this.state.selectedPayrollExpensesHierarchies.length
		if (selectedCount === 0 && this.selectedPayrollExpensesEmployees.length === 0) {
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_payroll_hierarchy)
		}
		else if (selectedCount === 0 && this.selectedPayrollExpensesEmployees.length > 0) {
			const selectedPayrollExpensesEmployeeIds = this.selectedPayrollExpensesEmployees.map(i => i.EmployeeId)
			this.checkPayrollExpensesHierarchyLocked(selectedPayrollExpensesEmployeeIds) ?
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Lock_Selected_Employees,
					content: strings.Cannot_lock_selected_employees_because_payroll_hirarchy_locked
				}) :
				AppStateStore.setConfirmDialogContent({
					title: strings.Lock_Payroll_Employees,
					content: strings.Are_you_sure_you_want_to_lock_payroll_employees,
					confirm: () => AccountStore.getExpenseIsPayrollTime() ?
						this.lockPayrollTimeExpensesHierarchy(false, selectedPayrollExpensesEmployeeIds) :
						this.lockPayrollExpensesHierarchy(selectedPayrollExpensesEmployeeIds)
				})
		}
		else if (this.state.selectedPayrollExpensesHierarchies.filter(item => item.TotalApprovedEmployees !== item.TotalEmployees).length > 0) {
			AppStateStore.setConfirmDialogContent({
				title: strings.Lock_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					AccountStore.getExpenseIsPayrollTime() ?
						strings.Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_expenses_with_timecard :
						strings.Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_expenses :
					strings.formatString(
						AccountStore.getExpenseIsPayrollTime() ?
							strings.Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_expenses_with_timecard :
							strings.Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_expenses,
						selectedCount
					) as string,
				confirm: () => AccountStore.getExpenseIsPayrollTime() ?
					this.lockPayrollTimeExpensesHierarchy(false, []) :
					this.lockPayrollExpensesHierarchy([])
			})
		}
		else {
			AppStateStore.setConfirmDialogContent({
				title: strings.Lock_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					strings.Are_you_sure_you_want_to_lock_payroll_hierarchy :
					strings.formatString(strings.Are_you_sure_you_want_to_lock_payroll_hierarchies, selectedCount) as string,
				confirm: () => AccountStore.getExpenseIsPayrollTime() ?
					this.lockPayrollTimeExpensesHierarchy(false, []) :
					this.lockPayrollExpensesHierarchy([])
			})
		}
	}

	onExpensesEmployeeLock() {
		const selectedCount = this.state.selectedPayrollExpensesHierarchies.length
		if (selectedCount === 0) {
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_payroll_hierarchy)
		}
		else {
			AppStateStore.setConfirmDialogContent({
				title: strings.Employee_Lock_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					strings.Are_you_sure_you_want_to_employee_lock_payroll_hierarchy :
					strings.formatString(strings.Are_you_sure_you_want_to_employee_lock_payroll_hierarchies, selectedCount) as string,
				confirm: () => AccountStore.getExpenseIsPayrollTime() ?
					this.employeeLockPayrollTimeExpensesHierarchy(false) :
					this.employeeLockPayrollExpensesHierarchy()
			})
		}
	}

	lockPayrollExpensesHierarchy(individualLockEmployeeIds: string[]) {
		AppStateStore.setProgressSnackbarContent("loading")
		api.lockPayrollExpensesHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollExpensesHierarchies),
			this.getPayGroupIds(),
			individualLockEmployeeIds,
			this.state.payrollExpensesData.PayrollDates.StartDate,
			this.state.payrollExpensesData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
			.then(res => {
				this.initSelectedPayrollExpensesState()
				AppStateStore.setProgressSnackbarContent(strings.Payroll_locked_successfully)
				this.setState({ payrollExpensesData: res.data })
			})
			.catch(err => {
				AppStateStore.setProgressSnackbarContent(err.response.data.message ? err.response.data.message : strings.Failed_to_lock_payroll_Please_try_again_later)
			})
	}

	employeeLockPayrollExpensesHierarchy() {
		AppStateStore.setProgressSnackbarContent("loading")
		api.employeeLockPayrollExpensesHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollExpensesHierarchies),
			this.getPayGroupIds(),
			this.state.payrollExpensesData.PayrollDates.StartDate,
			this.state.payrollExpensesData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
			.then(res => {
				this.initSelectedPayrollExpensesState()
				AppStateStore.setProgressSnackbarContent(strings.Payroll_employee_locked_successfully)
				this.setState({ payrollExpensesData: res.data })
			})
			.catch(err => {
				AppStateStore.setProgressSnackbarContent(err.response.data.message ? err.response.data.message : strings.Failed_to_employee_lock_payroll_Please_try_again_later)
			})
	}

	initSelectedPayrollExpensesState() {
		this.setState({ selectedPayrollExpensesHierarchies: [] })
		this.PayrollByHierarchyCard &&
			this.PayrollByHierarchyCard.PayrollExpensesByHierarchy &&
			this.PayrollByHierarchyCard.PayrollExpensesByHierarchy.PayrollExpensesByHierarchyTable &&
			this.PayrollByHierarchyCard.PayrollExpensesByHierarchy.PayrollExpensesByHierarchyTable.setState({
				selectedHierarchies: []
			})
		this.selectedPayrollExpensesEmployees = []
		if (this.state.payrollExpensesData) {
			this.state.payrollExpensesData.PayrollExpensesHierarchies.forEach((payrollHierarchy, index) => {
				this.PayrollByHierarchyCard &&
					this.PayrollByHierarchyCard.PayrollExpensesByHierarchy &&
					this.PayrollByHierarchyCard.PayrollExpensesByHierarchy.PayrollExpensesByHierarchyTable &&
					this.PayrollByHierarchyCard.PayrollExpensesByHierarchy.PayrollExpensesByHierarchyTable.PayrollExpensesByHierarchyEmployeeRow[index].setState({
						selectedEmployees: []
					})
			})
		}
	}

	onExpensesUnLock() {
		const selectedCount = this.state.selectedPayrollExpensesHierarchies.length
		if (selectedCount === 0 && this.selectedPayrollExpensesEmployees.length === 0) {
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_payroll_hierarchy)
		}
		else if (selectedCount === 0 && this.selectedPayrollExpensesEmployees.length > 0) {
			const selectedPayrollExpensesEmployeeIds = this.selectedPayrollExpensesEmployees.map(i => i.EmployeeId)
			if (this.checkPayrollExpensesHierarchyLocked(selectedPayrollExpensesEmployeeIds)) {
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Unlock_Payroll_Employees,
					content: strings.Cannot_unlock_selected_employees_because_payroll_hierarchy_locked
				})
			}
			else {
				const exportedEmployeeIdsTemp = this.state.payrollExpensesData.PayrollExpensesHierarchies.map(hierarchy => hierarchy.ExportedData.map(i => i.ExportedEmployeeId))
				const exportedEmployeeIds = [].concat.apply([], exportedEmployeeIdsTemp)
				selectedPayrollExpensesEmployeeIds.some(item => exportedEmployeeIds.includes(item)) ?
					AppStateStore.setAlertDialogContent({
						title: strings.Cannot_Unlock_Payroll_Employees,
						content: strings.Cannot_unlock_selected_employees_because_exported_employee_exist
					}) :
					AppStateStore.setConfirmDialogContent({
						title: strings.Unlock_Payroll_Employees,
						content: strings.Are_you_sure_you_want_to_unlock_payroll_employees,
						confirm: () => AccountStore.getExpenseIsPayrollTime() ?
							this.unlockPayrollTimeExpensesHierarchy(false, selectedPayrollExpensesEmployeeIds) :
							this.unlockPayrollExpensesHierarchy(selectedPayrollExpensesEmployeeIds)
					})
			}
		}
		else {
			AppStateStore.setConfirmDialogContent({
				title: strings.Unlock_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					strings.Are_you_sure_you_want_to_unlock_payroll_hierarchy :
					strings.formatString(strings.Are_you_sure_you_want_to_unlock_payroll_hierarchies, selectedCount) as string,
				confirm: () => AccountStore.getExpenseIsPayrollTime() ?
					this.unlockPayrollTimeExpensesHierarchy(false, null) :
					this.unlockPayrollExpensesHierarchy(null)
			})
		}
	}

	onExpensesEmployeeUnLock() {
		const selectedCount = this.state.selectedPayrollExpensesHierarchies.length
		selectedCount === 0 ?
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_payroll_hierarchy) :
			this.state.selectedPayrollExpensesHierarchies.find(i => i.LockedData.IsLocked === true) ?
				AppStateStore.setProgressSnackbarContent(strings.Cannot_employee_unlock_for_locked_hierarchy) :
				AppStateStore.setConfirmDialogContent({
					title: strings.Employee_Unlock_Payroll_Hierarchy,
					content: selectedCount === 1 ?
						strings.Are_you_sure_you_want_to_employee_unlock_payroll_hierarchy :
						strings.formatString(strings.Are_you_sure_you_want_to_employee_unlock_payroll_hierarchies, selectedCount) as string,
					confirm: () => AccountStore.getExpenseIsPayrollTime() ?
						this.employeeUnlockPayrollTimeExpensesHierarchy(false) :
						this.employeeUnlockPayrollExpensesHierarchy()
				})
	}

	unlockPayrollExpensesHierarchy(individualLockEmployeeIds: string[]) {
		AppStateStore.setProgressSnackbarContent("loading")
		api.unlockPayrollExpensesHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollExpensesHierarchies),
			this.getPayGroupIds(),
			individualLockEmployeeIds,
			this.state.payrollExpensesData.PayrollDates.StartDate,
			this.state.payrollExpensesData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
			.then(res => {
				this.initSelectedPayrollExpensesState()
				AppStateStore.setProgressSnackbarContent(strings.Payroll_unlocked_successfully)
				this.setState({ payrollExpensesData: res.data })
			})
			.catch(() => {
				AppStateStore.setProgressSnackbarContent(strings.Failed_to_unlock_payroll_Please_try_again_later)
			})
	}

	employeeUnlockPayrollExpensesHierarchy() {
		AppStateStore.setProgressSnackbarContent("loading")
		api.employeeUnlockPayrollExpensesHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollExpensesHierarchies),
			this.getPayGroupIds(),
			this.state.payrollExpensesData.PayrollDates.StartDate,
			this.state.payrollExpensesData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
			.then(res => {
				this.initSelectedPayrollExpensesState()
				AppStateStore.setProgressSnackbarContent(strings.Payroll_employee_unlocked_successfully)
				this.setState({ payrollExpensesData: res.data })
			})
			.catch(() => {
				AppStateStore.setProgressSnackbarContent(strings.Failed_to_employee_unlock_payroll_Please_try_again_later)
			})
	}

	onExpensesClose() {
		const selectedCount = this.state.selectedPayrollExpensesHierarchies.length
		this.state.selectedPayrollExpensesHierarchies.filter(item => item.LockedData.IsLocked).length === this.state.selectedPayrollExpensesHierarchies.length ?
			AppStateStore.setConfirmDialogContent({
				title: strings.Close_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					strings.Are_you_sure_you_want_to_close_payroll_hierarchy :
					strings.formatString(strings.Are_you_sure_you_want_to_close_payroll_hierarchies, selectedCount) as string,
				confirm: () => AccountStore.getExpenseIsPayrollTime() ?
					this.closePayrollTimeExpensesHierarchy(false) :
					this.closePayrollExpensesHierarchy()
			}) :
			AppStateStore.setConfirmDialogContent({
				title: strings.Close_Payroll_Hierarchy,
				content: selectedCount === 1 ?
					strings.Are_you_sure_you_want_to_close_payroll_hierarchy_before_lock :
					strings.formatString(strings.Are_you_sure_you_want_to_close_payroll_hierarchies_before_lock, selectedCount) as string,
				confirm: () => AccountStore.getExpenseIsPayrollTime() ?
					this.closeUnlockedPayrollTimeExpensesHierarchy(false) :
					this.closeUnlockedPayrollExpensesHierarchy()
			})
	}

	closePayrollExpensesHierarchy() {
		AppStateStore.setProgressSnackbarContent("loading")
		api.closePayrollExpensesHierarchy(
			AuthenticationStore.getCookieAccountId(),
			this.getPayrollPayGroupDataList(this.state.selectedPayrollExpensesHierarchies),
			this.getPayGroupIds(),
			this.state.payrollExpensesData.PayrollDates.StartDate,
			this.state.payrollExpensesData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId()
		)
			.then((res) => {
				this.initSelectedPayrollExpensesState()
				AppStateStore.setProgressSnackbarContent(strings.Payroll_closed_successfully)
				this.setState({ payrollExpensesData: res.data })
			})
			.catch(err => {
				AppStateStore.setProgressSnackbarContent(err.response.data.message ? err.response.data.message : strings.Failed_to_close_payroll_Please_try_again_later)
			})
	}

	closeUnlockedPayrollExpensesHierarchy() {
		AppStateStore.setProgressSnackbarContent("loading")
		const unlockedPayrollPayGroupDataList: IPayrollPayGroupData[] = []
		this.state.selectedPayrollExpensesHierarchies.forEach(item => !item.LockedData.IsLocked && unlockedPayrollPayGroupDataList.push(this.getPayrollPayGroupData(item)))
		const payGroupIds = this.getPayGroupIds()
		api.lockPayrollExpensesHierarchy(
			AuthenticationStore.getCookieAccountId(),
			unlockedPayrollPayGroupDataList,
			payGroupIds,
			[],
			this.state.payrollExpensesData.PayrollDates.StartDate,
			this.state.payrollExpensesData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId(),
		)
			.then(() => {
				const unclosedPayrollPayGroupDataList: IPayrollPayGroupData[] = []
				this.state.selectedPayrollExpensesHierarchies.forEach((item) => !item.ClosedData.IsClosed && unclosedPayrollPayGroupDataList.push(this.getPayrollPayGroupData(item)))
				api.closePayrollExpensesHierarchy(
					AuthenticationStore.getCookieAccountId(),
					unclosedPayrollPayGroupDataList,
					payGroupIds,
					this.state.payrollExpensesData.PayrollDates.StartDate,
					this.state.payrollExpensesData.PayrollDates.EndDate,
					HierarchySettingsStore.getGlobalLevelItemFilterId()
				)
					.then((res) => {
						this.initSelectedPayrollExpensesState()
						AppStateStore.setProgressSnackbarContent(strings.Payroll_closed_successfully)
						this.setState({ payrollExpensesData: res.data })
					})
					.catch(err => AppStateStore.setProgressSnackbarContent(err.response.data.message))
			})
			.catch(err => {
				AppStateStore.setProgressSnackbarContent(err.response.data.message ? err.response.data.message : strings.Failed_to_lock_payroll_Please_try_again_later)
			})
	}

	onExpensesExport() {
		if (this.selectedPayrollExpensesEmployees.length === 0) {
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_employee)
			return
		}

		const lockedData = this.selectedPayrollExpensesEmployees.map(i => {
			const lockedData = this.state.payrollExpensesData.PayrollExpensesHierarchies.find(e =>
				e.Employees.find(k => k.EmployeeId === i.EmployeeId)).LockedData
			return (lockedData.IsLocked ||
				lockedData.LockedObjData.find(k => k.LockedObjId === i.EmployeeId) ? true : false)
		})

		if (lockedData.find(i => !i) === false) {
			AppStateStore.setProgressSnackbarContent(strings.Cannot_export_payroll_for_unlocked_employee)
			return
		}

		const unapprovedPayrollExpensesEmployees = this.selectedPayrollExpensesEmployees.filter(employee => employee.AllExpensesApproved === false)
		const exportedPayrollExpensesEmployees = this.selectedPayrollExpensesEmployees.filter(employee => employee.Exported === true)
		if (exportedPayrollExpensesEmployees.length === 0) {
			if (unapprovedPayrollExpensesEmployees.length === 0) {
				AppStateStore.setConfirmDialogContent({
					title: strings.Export_Payroll,
					content: this.selectedPayrollExpensesEmployees.length === 1 ?
						strings.Are_you_sure_you_want_to_export_payroll_for_the_selected_employee :
						strings.formatString(strings.Are_you_sure_you_want_to_export_payroll_for_the_selected_employees, this.selectedPayrollExpensesEmployees.length) as string,
					confirm: () => this.exportPayrollExpensesEmployee()
				})
				return
			}

			const confirmDialogContent = this.selectedPayrollExpensesEmployees.length === 1 ?
				strings.Selected_employee_unapproved_Are_you_sure_you_want_to_export_employee :
				unapprovedPayrollExpensesEmployees.length === 1 ?
					strings.formatString(
						strings.Selected_employee_unapproved_Are_you_sure_you_want_to_export_employees,
						unapprovedPayrollExpensesEmployees.length,
						this.selectedPayrollExpensesEmployees.length
					) :
					strings.formatString(
						strings.Selected_employees_unapproved_Are_you_sure_you_want_to_export_employees,
						unapprovedPayrollExpensesEmployees.length,
						this.selectedPayrollExpensesEmployees.length
					)
			AppStateStore.setConfirmDialogContent({
				title: strings.Export_Payroll,
				content: confirmDialogContent as string,
				confirm: () => this.exportPayrollExpensesEmployee()
			})
		}
		else {
			this.unapprovedPayrollExpensesEmployees = unapprovedPayrollExpensesEmployees
			this.exportedPayrollExpensesEmployees = exportedPayrollExpensesEmployees
			this.setState({ openExportAgainPayrollConfirmDialog: EPayrollType.Expenses })
		}
	}

	onExpensePayrollFileDownload(expenseId: string) {
		AppStateStore.setProgressSnackbarContent("loading")
		payrollActions
			.expensePayrollFileDownload(
				AuthenticationStore.getCookieAccountId(),
				expenseId
			)
			.then((res) => {
				this.initSelectedPayrollExpensesState()
				AppStateStore.setProgressSnackbarContent("File Download Complete")
				this.setState({ payrollExpensesData: res.data.ReturnPayrollExpenses })

				//Initiate download of actual PayrollExpenses file
				setTimeout(() => {
					window.location = res.data.PayrollExpensesDownloadFileUrl
				}, 0)
			})
			.catch((ex) => {
				console.log("ex:")
				console.log(ex)
				AppStateStore.setProgressSnackbarContent(strings.Failed_to_export_payroll_Please_try_again_later)
			})
	}

	onPriorPeriodExpensesDownload() {
		payrollActions.downloadPayrollExpensesFile(AuthenticationStore.getCookieAccountId(), HierarchySettingsStore.getGlobalLevelItemFilterId(), this.getPayGroupIds(), moment(this.state.referenceDate).utc(true).format(), true)
	}

	onPriorPeriodExpensesExport() {
		if (!this.selectedPayrollPriorPeriodExpensesEmployees || this.selectedPayrollPriorPeriodExpensesEmployees.length === 0) {
			AppStateStore.setProgressSnackbarContent(strings.Please_choose_employee)
			return
		}

		const confirmDialogContent = "Are you sure you want to export all unexported prior period expenses?"

		AppStateStore.setConfirmDialogContent({
			title: strings.Export_Payroll,
			content: confirmDialogContent as string,
			confirm: () => this.exportPayrollPriorPeriodExpensesEmployee()
		})
		//this.setState({ openExportAgainPayrollConfirmDialog: EPayrollType.Expenses })
	}

	exportPayrollExpensesEmployee(exportAgain = false) {
		let { selectedPayrollExpensesEmployees } = this
		if (!exportAgain) {
			selectedPayrollExpensesEmployees = selectedPayrollExpensesEmployees.filter(employee => employee.Exported === false)
		}
		const selectedPayrollExpensesEmployeeIds = selectedPayrollExpensesEmployees.map(employee => employee.EmployeeId)
		AppStateStore.setProgressSnackbarContent("loading")
		payrollActions
			.exportEmployeePayrollExpenses(
				AuthenticationStore.getCookieAccountId(),
				selectedPayrollExpensesEmployeeIds,
				this.getPayGroupIds(),
				this.state.payrollExpensesData.PayrollDates.StartDate,
				this.state.payrollExpensesData.PayrollDates.EndDate,
				HierarchySettingsStore.getGlobalLevelItemFilterId()
			)
			.then((res) => {
				this.initSelectedPayrollExpensesState()
				AppStateStore.setProgressSnackbarContent(strings.Payroll_exported_successfully)
				this.setState({ payrollExpensesData: res.data.ReturnPayrollExpenses })

				//Initiate download of actual PayrollExpenses file
				setTimeout(() => {
					window.location = res.data.PayrollExpensesDownloadFileUrl
				}, 0)
			})
			.catch(() => {
				AppStateStore.setProgressSnackbarContent(strings.Failed_to_export_payroll_Please_try_again_later)
			})
	}

	initSelectedPayrollPriorPeriodExpensesState() {
		this.setState({ selectedPayrollPriorPeriodExpensesHierarchies: [] })
		this.PayrollByHierarchyCard &&
			this.PayrollByHierarchyCard.PayrollExpensesPriorPeriodByHierarchy &&
			this.PayrollByHierarchyCard.PayrollExpensesPriorPeriodByHierarchy.PayrollPriorPeriodExpensesByHierarchyTable &&
			this.PayrollByHierarchyCard.PayrollExpensesPriorPeriodByHierarchy.PayrollPriorPeriodExpensesByHierarchyTable.setState({
				selectedHierarchies: []
			})
		this.selectedPayrollPriorPeriodExpensesEmployees = []
		if (this.state.payrollPriorPeriodExpensesData) {
			this.state.payrollPriorPeriodExpensesData.PayrollExpensesHierarchies.forEach((payrollHierarchy, index) => {
				this.PayrollByHierarchyCard &&
					this.PayrollByHierarchyCard.PayrollExpensesPriorPeriodByHierarchy &&
					this.PayrollByHierarchyCard.PayrollExpensesPriorPeriodByHierarchy.PayrollPriorPeriodExpensesByHierarchyTable &&
					this.PayrollByHierarchyCard.PayrollExpensesPriorPeriodByHierarchy.PayrollPriorPeriodExpensesByHierarchyTable.PayrollExpensesByHierarchyEmployeeRow[index].setState({
						selectedEmployees: []
					})
			})
		}
	}

	exportPayrollPriorPeriodExpensesEmployee(exportAgain = false) {
		const selectedPayrollPriorPeriodExpensesEmployeeIds = this.selectedPayrollPriorPeriodExpensesEmployees.map(employee => employee.EmployeeId)

		AppStateStore.setProgressSnackbarContent("loading")
		payrollActions
			.exportEmployeePayrollPriorPeriodExpenses(
				AuthenticationStore.getCookieAccountId(),
				selectedPayrollPriorPeriodExpensesEmployeeIds,
				this.getPayGroupIds(),
				this.state.payrollExpensesData.PayrollDates.StartDate,
				this.state.payrollExpensesData.PayrollDates.EndDate,
				HierarchySettingsStore.getGlobalLevelItemFilterId()
			)
			.then((res) => {
				this.initSelectedPayrollPriorPeriodExpensesState()
				AppStateStore.setProgressSnackbarContent(strings.Payroll_exported_successfully)
				this.setState({ payrollPriorPeriodExpensesData: res.data.ReturnPayrollExpenses })

				//Initiate download of actual PayrollPriorPeriodExpenses file
				setTimeout(() => {
					window.location = res.data.PayrollExpensesDownloadFileUrl
					this.setState({ calculating: true, loadingTime: true, loadingExpenses: true }, () => {
						this.getPayrollTimeData()
						this.getPayrollExpensesData()
						this.getPayrollPriorPeriodExpensesData()
					})
				}, 0)

			})
			.catch(() => {
				AppStateStore.setProgressSnackbarContent(strings.Failed_to_export_payroll_Please_try_again_later)
			})
	}

	handleSelectPayrollExpensesEmployee(selectedEmployees: IPayrollExpensesHierarchyEmployee[], unselectedEmployees: IPayrollExpensesHierarchyEmployee[]) {
		const allPayrollExpensesHierarchyEmployees = selectedEmployees.concat(unselectedEmployees)
		this.selectedPayrollExpensesEmployees = this.selectedPayrollExpensesEmployees.filter(item => {
			return allPayrollExpensesHierarchyEmployees.find((unselectItem) => unselectItem.EmployeeId === item.EmployeeId) ? false : true
		})
		this.selectedPayrollExpensesEmployees = this.selectedPayrollExpensesEmployees.concat(selectedEmployees)
	}

	handleSelectPayrollPriorPeriodExpensesEmployee(selectedEmployees: IPayrollExpensesHierarchyEmployee[], unselectedEmployees: IPayrollExpensesHierarchyEmployee[]) {
		if (this.selectedPayrollPriorPeriodExpensesEmployees) {
			const allPayrollPriorPeriodExpensesHierarchyEmployees = selectedEmployees.concat(unselectedEmployees)
			this.selectedPayrollPriorPeriodExpensesEmployees = this.selectedPayrollPriorPeriodExpensesEmployees.filter(item => {
				return allPayrollPriorPeriodExpensesHierarchyEmployees.find((unselectItem) => unselectItem.EmployeeId === item.EmployeeId) ? false : true
			})
			this.selectedPayrollPriorPeriodExpensesEmployees = this.selectedPayrollPriorPeriodExpensesEmployees.concat(selectedEmployees)
		}
	}

	lockPayrollTimeExpensesHierarchy(lockByTime: boolean, individualLockEmployeeIds: string[]) {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		const payrollPayGroupDataList: IPayrollPayGroupData[] = lockByTime ?
			this.state.selectedPayrollTimeHierarchies.map(item => this.getPayrollPayGroupData(item)) :
			this.state.selectedPayrollExpensesHierarchies.map(item => this.getPayrollPayGroupData(item))

		const payGroupIds = this.getPayGroupIds()
		payrollActions.lockPayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			payrollPayGroupDataList,
			payGroupIds,
			individualLockEmployeeIds,
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId(),
			() => api.lockPayrollExpensesHierarchy(
				AuthenticationStore.getCookieAccountId(),
				payrollPayGroupDataList,
				payGroupIds,
				individualLockEmployeeIds,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.StartDate :
					this.state.payrollExpensesData.PayrollDates.StartDate,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.EndDate :
					this.state.payrollExpensesData.PayrollDates.EndDate,
				HierarchySettingsStore.getGlobalLevelItemFilterId()
			)
				.then(res => {
					!AccountStore.getPayrollLambdaEnabled() &&
						AppStateStore.setProgressSnackbarContent(strings.Payroll_locked_successfully)
					if (AccountStore.getExpenseIsPayrollTime()) return
					this.initSelectedPayrollExpensesState()
					this.setState({ payrollExpensesData: res.data })
				})
				.catch(err => {
					AppStateStore.setProgressSnackbarContent(err.response.data.message ? err.response.data.message : strings.Failed_to_lock_payroll_Please_try_again_later)
				})
		)
	}

	employeeLockPayrollTimeExpensesHierarchy(lockByTime: boolean) {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		const payrollPayGroupDataList: IPayrollPayGroupData[] = lockByTime ?
			this.state.selectedPayrollTimeHierarchies.map(item => this.getPayrollPayGroupData(item)) :
			this.state.selectedPayrollExpensesHierarchies.map(item => this.getPayrollPayGroupData(item))

		const payGroupIds = this.getPayGroupIds()
		payrollActions.employeeLockPayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			payrollPayGroupDataList,
			payGroupIds,
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId(),
			() => api.employeeLockPayrollExpensesHierarchy(
				AuthenticationStore.getCookieAccountId(),
				payrollPayGroupDataList,
				payGroupIds,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.StartDate :
					this.state.payrollExpensesData.PayrollDates.StartDate,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.EndDate :
					this.state.payrollExpensesData.PayrollDates.EndDate,
				HierarchySettingsStore.getGlobalLevelItemFilterId()
			)
				.then(res => {
					!AccountStore.getPayrollLambdaEnabled() &&
						AppStateStore.setProgressSnackbarContent(strings.Payroll_employee_locked_successfully)
					if (AccountStore.getExpenseIsPayrollTime()) return
					this.initSelectedPayrollExpensesState()
					this.setState({ payrollExpensesData: res.data })
				})
				.catch(err => {
					AppStateStore.setProgressSnackbarContent(err.response.data.message ? err.response.data.message : strings.Failed_to_employee_lock_payroll_Please_try_again_later)
				})
		)
	}

	unlockPayrollTimeExpensesHierarchy(unlockByTime: boolean, individualLockEmployeeIds: string[]) {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		const payrollPayGroupDataList: IPayrollPayGroupData[] = unlockByTime ?
			this.state.selectedPayrollTimeHierarchies.map(item => this.getPayrollPayGroupData(item)) :
			this.state.selectedPayrollExpensesHierarchies.map(item => this.getPayrollPayGroupData(item))

		const payGroupIds = this.getPayGroupIds()
		payrollActions.unlockPayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			payrollPayGroupDataList,
			payGroupIds,
			individualLockEmployeeIds,
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId(),
			() => api.unlockPayrollExpensesHierarchy(
				AuthenticationStore.getCookieAccountId(),
				payrollPayGroupDataList,
				payGroupIds,
				individualLockEmployeeIds,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.StartDate :
					this.state.payrollExpensesData.PayrollDates.StartDate,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.EndDate :
					this.state.payrollExpensesData.PayrollDates.EndDate,
				HierarchySettingsStore.getGlobalLevelItemFilterId()
			)
				.then(res => {
					AppStateStore.setProgressSnackbarContent(strings.Payroll_unlocked_successfully)
					if (AccountStore.getExpenseIsPayrollTime()) return
					this.initSelectedPayrollExpensesState()
					this.setState({ payrollExpensesData: res.data })
				})
				.catch(() => {
					AppStateStore.setProgressSnackbarContent(strings.Failed_to_unlock_payroll_Please_try_again_later)
				})
		)
	}

	employeeUnlockPayrollTimeExpensesHierarchy(unlockByTime: boolean) {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		const payrollPayGroupDataList: IPayrollPayGroupData[] = unlockByTime ?
			this.state.selectedPayrollTimeHierarchies.map(item => this.getPayrollPayGroupData(item)) :
			this.state.selectedPayrollExpensesHierarchies.map(item => this.getPayrollPayGroupData(item))

		const payGroupIds = this.getPayGroupIds()
		payrollActions.employeeUnlockPayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			payrollPayGroupDataList,
			payGroupIds,
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId(),
			() => api.employeeUnlockPayrollExpensesHierarchy(
				AuthenticationStore.getCookieAccountId(),
				payrollPayGroupDataList,
				payGroupIds,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.StartDate :
					this.state.payrollExpensesData.PayrollDates.StartDate,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.EndDate :
					this.state.payrollExpensesData.PayrollDates.EndDate,
				HierarchySettingsStore.getGlobalLevelItemFilterId()
			)
				.then(res => {
					AppStateStore.setProgressSnackbarContent(strings.Payroll_employee_unlocked_successfully)
					if (AccountStore.getExpenseIsPayrollTime()) return
					this.initSelectedPayrollExpensesState()
					this.setState({ payrollExpensesData: res.data })
				})
				.catch(() => {
					AppStateStore.setProgressSnackbarContent(strings.Failed_to_employee_unlock_payroll_Please_try_again_later)
				})
		)
	}

	closePayrollTimeExpensesHierarchy(closeByTime: boolean) {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		const payrollPayGroupDataList: IPayrollPayGroupData[] = closeByTime ?
			this.state.selectedPayrollTimeHierarchies.map(item => this.getPayrollPayGroupData(item)) :
			this.state.selectedPayrollExpensesHierarchies.map(item => this.getPayrollPayGroupData(item))
		const payGroupIds = this.getPayGroupIds()
		payrollActions.closePayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			payrollPayGroupDataList,
			payGroupIds,
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId(),
			() => api.closePayrollExpensesHierarchy(
				AuthenticationStore.getCookieAccountId(),
				payrollPayGroupDataList,
				payGroupIds,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.StartDate :
					this.state.payrollExpensesData.PayrollDates.StartDate,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.EndDate :
					this.state.payrollExpensesData.PayrollDates.EndDate,
				HierarchySettingsStore.getGlobalLevelItemFilterId()
			)
				.then((res) => {
					AppStateStore.setProgressSnackbarContent(strings.Payroll_closed_successfully)
					if (AccountStore.getExpenseIsPayrollTime()) return
					this.initSelectedPayrollExpensesState()
					this.setState({ payrollExpensesData: res.data })
				})
				.catch(() => {
					AppStateStore.setProgressSnackbarContent(strings.Failed_to_close_payroll_Please_try_again_later)
				})
		)
	}

	closeUnlockedPayrollTimeExpensesHierarchy(closeByTime: boolean) {
		AppStateStore.setProgressSnackbarContent("loading")
		this.initSelectedPayrollTimeState = true
		const selectedPayrollHierarchies = closeByTime ? this.state.selectedPayrollTimeHierarchies : this.state.selectedPayrollExpensesHierarchies

		const unlockedPayrollPayGroupDataList: IPayrollPayGroupData[] = []
		selectedPayrollHierarchies.forEach((item) => !item.LockedData.IsLocked && unlockedPayrollPayGroupDataList.push(this.getPayrollPayGroupData(item)))
		const unclosedPayrollPayGroupDataList: IPayrollPayGroupData[] = []
		selectedPayrollHierarchies.forEach((item) => !item.ClosedData.IsClosed && unclosedPayrollPayGroupDataList.push(this.getPayrollPayGroupData(item)))
		const payGroupIds = this.getPayGroupIds()

		payrollActions.lockClosePayrollTimeHierarchy(
			AuthenticationStore.getCookieAccountId(),
			unlockedPayrollPayGroupDataList,
			unclosedPayrollPayGroupDataList,
			payGroupIds,
			this.state.payrollTimeData.PayrollDates.StartDate,
			this.state.payrollTimeData.PayrollDates.EndDate,
			HierarchySettingsStore.getGlobalLevelItemFilterId(),
			() => api.lockPayrollExpensesHierarchy(
				AuthenticationStore.getCookieAccountId(),
				unlockedPayrollPayGroupDataList,
				payGroupIds,
				[],
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.StartDate :
					this.state.payrollExpensesData.PayrollDates.StartDate,
				AccountStore.getExpenseIsPayrollTime() ?
					this.state.payrollTimeData.PayrollDates.EndDate :
					this.state.payrollExpensesData.PayrollDates.EndDate,
				HierarchySettingsStore.getGlobalLevelItemFilterId(),
			)
				.then(() => {
					api.closePayrollExpensesHierarchy(
						AuthenticationStore.getCookieAccountId(),
						unclosedPayrollPayGroupDataList,
						payGroupIds,
						AccountStore.getExpenseIsPayrollTime() ?
							this.state.payrollTimeData.PayrollDates.StartDate :
							this.state.payrollExpensesData.PayrollDates.StartDate,
						AccountStore.getExpenseIsPayrollTime() ?
							this.state.payrollTimeData.PayrollDates.EndDate :
							this.state.payrollExpensesData.PayrollDates.EndDate,
						HierarchySettingsStore.getGlobalLevelItemFilterId()
					)
						.then((res) => {
							AppStateStore.setProgressSnackbarContent(strings.Payroll_closed_successfully)
							if (AccountStore.getExpenseIsPayrollTime()) return
							this.initSelectedPayrollExpensesState()
							this.setState({ payrollExpensesData: res.data })
						})
				})
				.catch(err => {
					AppStateStore.setProgressSnackbarContent(err.response.data.message ? err.response.data.message : strings.Failed_to_lock_payroll_Please_try_again_later)
				})
		)
	}

	reloadTimeCard() {
		this.getPayrollTimeData()
	}

	render() {
		return (
			<div className="page-container Users">
				{this.state.showOverlayLoading &&
					<div
						style={{
							zIndex: 990,
							position: "fixed",
							width: this.state.contentWidth,
							height: this.state.contentHeight - 70,
							backgroundColor: "#757575",
							opacity: 0.7,
							top: 70
						}}
					>
						<RefreshIndicator size={60} left={this.state.contentWidth / 2 - 30} top={this.state.contentHeight * 0.5 - 80} status="loading" />
					</div>
				}
				<div className="page-container-parent" style={{ minWidth: 1275 }}>
					<PayrollTopCard
						calculating={this.state.calculating}
						viewByJob={this.state.viewByJob}
						payrollDates={this.payrollDates}
						referenceDate={this.state.referenceDate}
						payCalendarPayGroups={this.payCalendarPayGroups}
						selectedPayCalendar={this.state.selectedPayCalendar}
						selectedPayGroup={this.state.selectedPayGroup}
						handleChangeReferenceDate={this.handleChangeReferenceDate}
						handleChangeSelectedPayCalendar={selectedPayCalendar => {
							this.payCalendarPayGroups = payrollHelper.getPayGroupsByPayrollPayCalendar(selectedPayCalendar)
							this.payrollDates = payrollHelper.getPayrollDatesByPayCalendar(moment(this.state.referenceDate), selectedPayCalendar)
							this.setState({ selectedPayCalendar, selectedPayGroup: this.payCalendarPayGroups.length === 1 ? this.payCalendarPayGroups[0] : null, calculating: false })
						}}
						handleChangeSelectedPayGroup={selectedPayGroup => {
							this.payrollDates = payrollHelper.getPayrollDatesByPayCalendar(moment(this.state.referenceDate), this.state.selectedPayCalendar)
							this.setState({ selectedPayGroup, calculating: false })
						}}
						handleChangeViewByJob={viewByJob => {
							localStorage.setItem("findd_PayrollViewByJob", viewByJob as any)
							this.setState({ viewByJob, calculating: false })
						}}
						handleCalculate={() =>
							this.setState({ calculating: true, loadingTime: true, loadingExpenses: true }, () => {
								this.getPayrollTimeData()
								this.getPayrollExpensesData()
								this.getPayrollPriorPeriodExpensesData()
							})
						}
					/>
					{this.state.calculating && [
						<PayrollChartCard
							key="chart"
							payrollTimeData={this.state.payrollTimeData}
							payrollExpensesData={this.state.payrollExpensesData}
							viewByJob={this.state.viewByJob}
						/>,
						permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll) &&
						<PayrollHoursSummaryCard
							key="hours"
							loading={this.state.loadingTime}
							payrollData={this.state.payrollTimeData}
						/>,
						permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll) &&
						<PayrollJobCostingSummaryCard
							key="jobcosting"
							loading={this.state.loadingTime}
							payrollData={this.state.payrollTimeData}
						/>,
						permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ExportPayroll) &&
						<PayrollExportHistoryCard
							key="exporthistory"
							historyList={this.state.payrollTimeData && this.state.payrollTimeData.ExportHistoryList}
						/>,
						permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll) &&
						<ExceptionPunchSets
							key="exception"
							isPayroll
							payGroupIds={this.getPayGroupIds()}
							referenceDate={this.state.referenceDate}
							localStorageKey="ExceptionFilterTypeStringForPayrollPage"

							filterDirectReportsOnly={false}
							filterByDefaultHierarchy={false}
							filterByPunchHierarchy={false}

							viewPayrollByJob={this.state.viewByJob}
						/>,
						<PayrollByHierarchyCard
							key="hierarchy"
							ref={elem => this.PayrollByHierarchyCard = elem}
							viewPayrollByJob={this.state.viewByJob}

							// payroll time props
							payrollTimeData={this.state.payrollTimeData}
							loadingTime={this.state.loadingTime}
							onTimeDownload={this.onTimeDownload}
							onTimeReportDownload={this.onTimeReportDownload}
							onTimeLock={this.onTimeLock}
							onTimeUnLock={this.onTimeUnLock}
							onTimeEmployeeLock={this.onTimeEmployeeLock}
							onTimeEmployeeUnLock={this.onTimeEmployeeUnLock}
							onTimeClose={this.onTimeClose}
							onTimeExport={this.onTimeExport}
							showTimecardPopup={this.showTimecardPopup}
							handleSelectPayrollTimeHierarchy={selectedPayrollTimeHierarchies => this.setState({ selectedPayrollTimeHierarchies })}
							handleSelectPayrollTimeEmployee={this.handleSelectPayrollTimeEmployee}
							selectedPayrollTimeHierarchies={this.state.selectedPayrollTimeHierarchies}
							selectedPayrollTimeEmployees={this.selectedPayrollTimeEmployees}
							handleInitSelectedPayrollTimeEmployees={() => this.selectedPayrollTimeEmployees = []}

							// payroll expenses props
							payrollExpensesData={this.state.payrollExpensesData}
							payrollPriorPeriodExpensesData={this.state.payrollPriorPeriodExpensesData}
							loadingExpenses={this.state.loadingExpenses}
							selectedPayrollExpenseHierarchies={this.state.selectedPayrollExpensesHierarchies}
							selectedPayrollExpenseEmployees={this.selectedPayrollExpensesEmployees}
							onExpensesDownload={this.onExpensesDownload}
							onExpensesReportDownload={this.onExpensesReportDownload}
							onExpensesLock={this.onExpensesLock}
							onExpensesUnLock={this.onExpensesUnLock}
							onExpensesEmployeeLock={this.onExpensesEmployeeLock}
							onExpensesEmployeeUnLock={this.onExpensesEmployeeUnLock}
							onExpensesClose={this.onExpensesClose}
							onExpensesExport={this.onExpensesExport}
							onPriorPeriodExpensesDownload={this.onPriorPeriodExpensesDownload}
							onPriorPeriodExpensesExport={this.onPriorPeriodExpensesExport}
							handleSelectPayrollExpensesHierarchy={selectedPayrollExpensesHierarchies => this.setState({ selectedPayrollExpensesHierarchies })}
							handleSelectPayrollExpensesEmployee={this.handleSelectPayrollExpensesEmployee}
							handleInitSelectedPayrollExpensesEmployees={() => this.selectedPayrollExpensesEmployees = []}

							handleSelectPayrollPriorPeriodExpensesHierarchy={selectedPayrollPriorPeriodExpensesHierarchies => this.setState({ selectedPayrollPriorPeriodExpensesHierarchies })}
							handleSelectPayrollPriorPeriodExpensesEmployee={this.handleSelectPayrollPriorPeriodExpensesEmployee}
							onExpensePayrollFileDownload={this.onExpensePayrollFileDownload}
							reloadTimeCard={this.reloadTimeCard}
						/>
					]}
				</div>
				{this.state.openTimecardPopup &&
					<TimecardPopup
						open={this.state.openTimecardPopup}
						employeeId={this.employeeIdForTimecard}
						referenceDate={this.referenceDateForTimecard}
						handleClose={this.closeTimcardPopup}
						handleRecalcPage={() => (this.recalcPayrollAferCloseTimecardPopup = true)}
					/>
				}
				{this.state.openExportAgainPayrollConfirmDialog !== null &&
					<ExportAgainPayrollConfirmDialog
						close={() => this.setState({ openExportAgainPayrollConfirmDialog: null })}
						confirm={exportAgain => {
							this.state.openExportAgainPayrollConfirmDialog === EPayrollType.Time ?
								this.exportPayrollTimeEmployee(exportAgain) :
								this.exportPayrollExpensesEmployee(exportAgain)
							this.setState({ openExportAgainPayrollConfirmDialog: null })
						}}
						unapprovedCount={this.state.openExportAgainPayrollConfirmDialog === EPayrollType.Time ?
							this.unapprovedPayrollTimeEmployees.length :
							this.unapprovedPayrollExpensesEmployees.length
						}
						exportedCount={this.state.openExportAgainPayrollConfirmDialog === EPayrollType.Time ?
							this.exportedPayrollTimeEmployees.length :
							this.exportedPayrollExpensesEmployees.length
						}
						selectedCount={this.state.openExportAgainPayrollConfirmDialog === EPayrollType.Time ?
							this.selectedPayrollTimeEmployees.length :
							this.selectedPayrollExpensesEmployees.length
						}
					/>
				}
				{this.state.exportHierarchyData && this.state.exportHierarchyData.length > 0 &&
					<ExportPayrollTimeConfirmDialog
						selectedPayCalendar={this.state.selectedPayCalendar}
						payrollDates={this.payrollDates}
						exportHierarchyData={this.state.exportHierarchyData}
						handleClose={() => this.setState({ exportHierarchyData: null })}
						handleExport={exportAgain => {
							this.setState({ exportHierarchyData: null })
							this.exportPayrollTimeEmployee(exportAgain)
						}}
					/>
				}
				{this.state.exportPayrollTimeResultEmployeeIds && this.state.exportPayrollTimeResultEmployeeIds.length > 0 && this.state.payrollTimeData &&
					<ExportPayrollResultDialog
						selectedPayCalendar={this.state.selectedPayCalendar}
						payrollDates={this.payrollDates}
						payrollTimeHierarchies={this.state.payrollTimeData.PayrollTimeHierarchies}
						exportEmployeeIds={this.state.exportPayrollTimeResultEmployeeIds}
						handleClose={() => payrollActions.closeExportPayrollTimeResultDialog()}
					/>
				}
			</div>
		)
	}
}
